<template>
  <section class="content white flex-grow">
    <table-uferdige-objekt :limit="50" :large="true" :brukerId="brukerId"/>
  </section>
</template>

<script>
import TableUferdigeObjekt from './TableUferdigeObjekt'

export default {
  name: 'PageUferdigeObjekt',
  components: {
    TableUferdigeObjekt
  },
  props: {
    brukerId: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/PageUferdigeObjekt.vue